import { render, staticRenderFns } from "./PagOnlineView.vue?vue&type=template&id=b11663d6&"
import script from "./PagOnlineView.vue?vue&type=script&lang=js&"
export * from "./PagOnlineView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports